<div kalDialogContent class="creditsDialog" [kalLoading]="loading">

    <h5 class="gup-O-titrage__subTitle">Imputation d’avoirs et acomptes sur la facture {{ data.invoice.NumFacture }}</h5>

    <kal-table [columns]="columns"
               class="no-action"
               virtual
               [virtualItemSize]="26"
               virtualViewPortHeight="calc(80vh - 300px)"
               [dataSource]="dataSource">

        <tr *kalHeaderRowDef kal-header-row></tr>
        <tr *kalFooterRowDef kal-footer-row></tr>

        <!-- Libelle facture -->
        <ng-container [kalColumn]="columns[0].code">
            <td *kalBodyCell="let row">{{ getCreditDepositLabel(row) }}</td>
            <td *kalFooterCell class="gup-U-stronger -textRight">
                <strong>Total</strong>
            </td>
        </ng-container>

        <!-- Montant Initial-->
        <ng-container [kalColumn]="columns[1].code">
            <td *kalBodyCell="let row">{{row.MontantFactureTotal | currency:'EUR'}}</td>
            <td *kalFooterCell>
                {{initialAmountSum | currency:'EUR'}}
            </td>
        </ng-container>

        <!-- Restant Disponible-->
        <ng-container [kalColumn]="columns[2].code">
            <td *kalBodyCell="let row">{{row.Solde | currency:'EUR'}}</td>
            <td *kalFooterCell>
                {{leftAmountSum | currency:'EUR'}}
            </td>
        </ng-container>

        <!-- Montant à utiliser-->
        <ng-container [kalColumn]="columns[3].code">
            <td *kalBodyCell="let row">
                <kal-input
                    type="currency"
                    icon="euro_symbol"
                    [formControl]="controls[row.Id]"
                    autocomplete="off">
                </kal-input>
            </td>
            <td *kalFooterCell>
                {{toUseAmountSum | currency:'EUR'}}
            </td>
        </ng-container>

    </kal-table>

    <div class="creditsDialog__leftToPayList gup-C-flexGroup -row -justifyBetween -alignStart">

        <div class="gup-C-flexGroup__item -tiers">

            <kal-form-field>
                <kal-datepicker [formControl]="dateControl"
                                id="credits_deposits_dialog_date"
                                label="Date d'imputation">
                </kal-datepicker>
            </kal-form-field>

        </div>

        <div class="gup-C-flexGroup__item">

            <div class="creditsDialog__leftToPay">Reste à payer initial : {{invoiceInitialAmount | currency:'EUR'}}</div>

            <div class="creditsDialog__leftToPay">
                Reste à payer après imputation :
                <span [ngClass]="{'gup-U-color--red -error' : invoiceAmountAfterAllocation < 0}">
                {{invoiceAmountAfterAllocation | currency:'EUR'}}
            </span>
            </div>

            <p *ngIf="invoiceAmountAfterAllocation < 0" class="gup-U-color--red -error small">Le montant à utiliser ne
                doit pas être supérieur au solde restant de la facture</p>

        </div>

    </div>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button id="credits_deposits_dialog_submit"
                        kalTheme="primary"
                        [disabled]="invalid"
                        (click)="checkAndSaveHeader()">
                Valider
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button id="credits_deposits_dialog_cancel"
                        kalTheme="secondary"
                        (click)="close()">
                Annuler
            </kal-button>

        </div>

    </div>

</div>
